import React from "react";

interface IconProps {
    className?: string;
  }

const PrompterIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width="437px"
    height="314px"
    viewBox="0 0 437 314"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Group 6</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-6" transform="translate(0.8889, 0)">
        <rect className="dark" id="Rectangle" fill="#000000" x="0" y="0" width="436.111111" height="314" rx="30" />
        <rect className="light" id="Rectangle" fill="#FFFFFF" x="52.3333333" y="52.3333333" width="264.421053" height="26.1666667" rx="13" />
        <rect className="light" id="Rectangle" fill="#FFFFFF" x="52.3333333" y="122.111111" width="181.789474" height="26.1666667" rx="13" />
        <rect className="light" id="Rectangle" fill="#FFFFFF" x="52.3333333" y="191.888889" width="314" height="26.1666667" rx="13" />
      </g>
    </g>
  </svg>
);

export default PrompterIcon;
